import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import { MessageCardContent } from 'widgets/MessageCard/ui/MessageCardContent'
import {
  type IMessageCardProps,
  MessageCardContext,
} from 'widgets/MessageCard/context/messageCardContext'

export const MessageCard: FC<IMessageCardProps> = observer(
  ({
    selectedSearch,
    callContentStore,
    setScrollBottomTrigger,
    message,
    isLast,
    hideTeam,
    conversationMessagesStore,
    reserveMediaSize,
  }) => {
    return (
      <MessageCardContext.Provider
        value={{
          selectedSearch,
          callContentStore,
          setScrollBottomTrigger,
          message,
          isLast,
          hideTeam,
          conversationMessagesStore,
          reserveMediaSize,
        }}
      >
        <MessageCardContent />
      </MessageCardContext.Provider>
    )
  }
)
